// extracted by mini-css-extract-plugin
export default {"innerWrapper":"CG-z","tooltipWrapper":"DG-z","icon":"EG-z","tooltip":"FG-z","content":"GG-z"};